import BaseModel from './base';

export const transformOrder = [
	'edited',
	'improved',
	'transformed',
	'resized',
	'original'
];

class TransactionModel extends BaseModel {
	// keys where transform operations can start from
	getBaseTransformItem(transaction) {
		return (
			transaction?.pipeline?.improved ?? transaction?.pipeline?.transformed
		);
	}

	getLatestTransformation(transaction) {
		for (const type of transformOrder) {
			const item = transaction?.pipeline?.[type];
			if (item) {
				return item;
			}
		}

		return null;
	}

	getBasePdf(transaction) {
		return transaction?.pipeline?.original;
	}

	async getTransactionById(transactionId) {
		const transaction = await this.get(`/${transactionId}`);

		return this.replacePipeline(transaction);
	}

	uploadPdf(pdfFile, filename) {
		const query = new URLSearchParams({ originalFileName: filename });

		const headers = {};

		return this.post(`/?${query}`, { body: pdfFile, headers });
	}

	async getTransactions(options = {}) {
		const query = new URLSearchParams(options);

		const result = await this.get(`/?${query}`);

		if (result?.transactions) {
			result.transactions = result.transactions.map(tx =>
				this.replacePipeline(tx)
			);
		}

		return result;
	}

	downloadUrl(id, type = 'pdf', filename) {
		const query = filename ? new URLSearchParams({ filename }) : '';
		return new URL(
			this.basePath + `/${id}/download/${type}?${query}`,
			window.location.origin
		);
	}

	downloadShareUrl(id) {
		return new URL(
			this.basePath + `/public/${id}/download`,
			window.location.origin
		);
	}

	deleteTransaction(id) {
		return this.delete(`/${id}`);
	}

	batchDelete(ids) {
		return this.post('/batch-delete', {
			body: { ids }
		});
	}

	#replaceLowQualityKeys(obj) {
		return Object.keys(obj).reduce((pipeline, key) => {
			pipeline[key.replace(':low', '')] = obj[key];
			return pipeline;
		}, {});
	}

	replacePipeline(transaction) {
		// replace `:low` suffix for easier use
		if (transaction?.pipeline) {
			transaction.pipeline = this.#replaceLowQualityKeys(
				transaction.pipeline
			);
		}

		return transaction;
	}

	sendByEmail(id, email, fileName, message) {
		return this.post(`/${id}/send-to-email`, {
			body: {
				email,
				...(fileName && { fileName }),
				...(message && { message })
			}
		});
	}

	updatePdf({ id, pdfFile, fileName }) {
		const params = fileName ? { originalFileName: fileName } : {};

		return this.put(`/${id}`, {
			body: pdfFile,
			params
		});
	}

	patchPdf({ id, fileName }) {
		const body = { originalFileName: fileName };

		return this.patch(`/${id}`, { body });
	}

	async getPublicTransaction(publicId) {
		const transaction = await this.get(`/public/${publicId}`);
		return this.replacePipeline(transaction);
	}

	registerFonts(id, fonts = []) {
		return this.post(`/${id}/fonts`, {
			body: fonts
		});
	}
}

export default new TransactionModel('/transaction');
